.month {
  outline: none;
  transition: opacity var(--dur-1) var(--ease-std);
}

.month:focus-visible .hit {
  stroke: var(--focus);
  stroke-width: 2px;
}

.hit {
  fill: transparent;
  rx: 4px;
}

.month:hover .hit {
  fill: var(--panel-2);
}

/* A month with no figures: a dashed mark on the baseline, never a zero-height bar. */
.gap {
  stroke: var(--muted);
  stroke-dasharray: 3 3;
  stroke-width: 2px;
}

.tipLine {
  display: block;
  font-variant-numeric: lining-nums tabular-nums;
}

/* Hover or focus on one month dims the rest, so the month under the cursor reads first. */
.dim {
  opacity: 0.45;
}

.openable {
  cursor: pointer;
}

/* A month that has not happened yet: a dashed outline, so it is told apart from a gap by shape. */
.future {
  fill: none;
  stroke: var(--line-2);
  stroke-dasharray: 4 3;
  stroke-width: 1.5px;
}

/* The legend's two extra entries. "Still arriving" is a pale fill (the bars use a lighter fill of
 * their own colour, with no outline); "Bills missing" is the small cap in the warning colour. */
.swatchPale {
  background: color-mix(in srgb, var(--muted) 32%, var(--panel));
}

.swatchCap {
  height: 4px;
  background: var(--warn);
}

@media (prefers-reduced-motion: reduce) {
  .month {
    transition: none;
  }
}
